import eventBus from 'toxilibs/event_bus_queued.js'
import globals from '../globals.js'
import JsonSynchronizer from 'toxilibs/json_synchronizer.js'

const synchronizer = new JsonSynchronizer({
    localStoragePrefix: 'silent_teacher'
})


//FIXME globals writing is part of this file ?

globals.errorsCount = 0

eventBus.on('levels loaded', init)

eventBus.on('level changed', recordCurrentLevel)

eventBus.on('user gave wrong answer', recordError)

eventBus.on('player wants to reset save', function () {
    synchronizer.clearLocal()
})



function init (levels) {

    readFromLocalStorage(levels)

    // FIXME - Use another key, levelID is not use for current level anymore
    if (globals.levelID === 'end') {
        eventBus.emit('already ended on start')
    }
}


function readFromLocalStorage () {
    const errors = synchronizer.getKey('errors')
    if (typeof errors !== 'undefined') {
        globals.errorsCount = parseInt(errors, 10)
    }
}


function recordCurrentLevel (levelID) {
    synchronizer.updateKey('level', levelID)
}


function recordError () {
    globals.errorsCount += 1 //FIXME
    synchronizer.updateKey('errors', globals.errorsCount)
}


export default  synchronizer

